const api = {
  GET_LIST_INTERNAL_SERVICE: '/index.php?r=api/v1/system_log/service-log/internal-service',
};

export default api;
